import styled from 'styled-components';

import { Autosuggest } from '@dreryk/react-components';

export const StyledPatientAutosuggest = styled(Autosuggest)`
   width: 538px;
` as typeof Autosuggest;
